// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import ElectionPost from "./election-post.js"
import VoteElectionPostContactResult from "./vote-election-post-contact-result.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "election_post_id": {
      "column": {
        "default": null,
        "name": "election_post_id",
        "null": false,
        "type": "uuid"
      },
      "name": "election_post_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "position": {
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ElectionPostContact",
  "collectionKey": "election_post_contacts",
  "collectionName": "election_post_contacts",
  "i18nKey": "election_post_contact",
  "camelizedLower": "electionPostContact",
  "name": "ElectionPostContact",
  "nameDasherized": "election-post-contact",
  "pluralName": "election_post_contacts",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_post_id",
      "name": "election_post",
      "macro": "belongs_to",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "VoteElectionPostContactResult",
      "collectionName": "vote_election_post_contact_results",
      "foreignKey": "election_post_contact_id",
      "name": "vote_election_post_contact_result",
      "macro": "has_one",
      "resource_name": "VoteElectionPostContactResult",
      "through": null
    },
    {
      "className": "VoteElectionPostContact",
      "collectionName": null,
      "foreignKey": "election_post_contact_id",
      "name": "vote_election_post_contacts",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Vote",
      "collectionName": null,
      "foreignKey": "vote_id",
      "name": "votes",
      "macro": "has_many",
      "resource_name": null,
      "through": "vote_election_post_contacts"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "election_post_id",
      "column": {
        "default": null,
        "name": "election_post_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_election_post_id",
      "column": {
        "default": null,
        "name": "old_election_post_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "position",
      "column": {
        "default": 0,
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "ElectionPost",
      "collectionName": "election_posts",
      "foreignKey": "election_post_id",
      "name": "election_post",
      "macro": "belongs_to",
      "resource_name": "ElectionPost",
      "through": null
    },
    {
      "className": "VoteElectionPostContactResult",
      "collectionName": "vote_election_post_contact_results",
      "foreignKey": "election_post_contact_id",
      "name": "vote_election_post_contact_result",
      "macro": "has_one",
      "resource_name": "VoteElectionPostContactResult",
      "through": null
    }
  ],
  "paramKey": "election_post_contact",
  "primaryKey": "id"
}

/** Frontend model for ElectionPostContact. */
export default class ElectionPostContact extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  electionPostId() {
    return this.readAttributeUnderscore("election_post_id")
  }

  /** @returns {boolean} */
  hasElectionPostId() {
    const value = this.electionPostId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./election-post.js").default | null} */
  electionPost() {
    return this._readBelongsToReflection({modelClass: ElectionPost, reflectionName: "election_post"})
  }

  /** @returns {Promise<import("./election-post.js").default | null>} */
  loadElectionPost() {
    if (!("electionPostId" in this)) throw new Error("Foreign key method wasn't defined: electionPostId")

    const id = this.electionPostId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "election_post",
        model: this,
        modelClass: ElectionPost
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./election-post.js").default | null>} */
  ensureElectionPostLoaded() {
    return this.ensureAssociationLoaded("election_post")
  }

  /** @returns {import("./vote-election-post-contact-result.js").default | null} */
  voteElectionPostContactResult() {
    return this._readHasOneReflection({modelClass: VoteElectionPostContactResult, reflectionName: "vote_election_post_contact_result"})
  }

  /** @returns {Promise<import("./vote-election-post-contact-result.js").default | null>} */
  loadVoteElectionPostContactResult() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["election_post_contact_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "vote_election_post_contact_result",
        model: this,
        modelClass: VoteElectionPostContactResult
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./vote-election-post-contact-result.js").default | null>} */
  ensureVoteElectionPostContactResultLoaded() {
    return this.ensureAssociationLoaded("vote_election_post_contact_result")
  }
}
